import { ROLES, CONFIGURATION_KEYS, TASKS_OVERVIEW, ORGANIZATION_HIERARCHY } from 'constants/enums'
import config from 'config'

export default [
  {
    id: 1,
    url: `${config.publicPath}/my-tasks/registration-participants`,
    urlPrefix: `${config.publicPath}/my-tasks`,
    icon: 'todo',
    defaultMessage: 'My To Do List',
    message: 'sidebar.my_todolist',
    roles: [ROLES.LEADER.u],
    counters: [
      TASKS_OVERVIEW.AWARD_REGISTRATION.id,
      TASKS_OVERVIEW.SECTION_APPROVAL.id,
      TASKS_OVERVIEW.SECTION_SIGNOFF.id,
      TASKS_OVERVIEW.AJ_SIGNOFF.id,
      TASKS_OVERVIEW.AWARD_SIGNOFF.id,
      TASKS_OVERVIEW.UNASSIGNED_PARTICIPANTS.id,
      TASKS_OVERVIEW.ASSESSOR_REGISTRATION.id,
      TASKS_OVERVIEW.EMAIL_REVISION.id
    ],
    countersMyOnly: true
  },
  {
    id: 2,
    url: `${config.publicPath}/tasks/registration-participants`,
    urlPrefix: `${config.publicPath}/tasks`,
    icon: 'todo',
    defaultMessage: 'To Do List',
    message: 'sidebar.todolist',
    roles: [ROLES.LEADER.u],
    counters: [
      TASKS_OVERVIEW.AWARD_REGISTRATION.id,
      TASKS_OVERVIEW.SECTION_APPROVAL.id,
      TASKS_OVERVIEW.SECTION_SIGNOFF.id,
      TASKS_OVERVIEW.AJ_SIGNOFF.id,
      TASKS_OVERVIEW.AWARD_SIGNOFF.id,
      TASKS_OVERVIEW.UNASSIGNED_PARTICIPANTS.id,
      TASKS_OVERVIEW.ASSESSOR_REGISTRATION.id,
      TASKS_OVERVIEW.EMAIL_REVISION.id
    ]
  },
  {
    id: 3,
    url: `${config.publicPath}/registrations/award-leaders`,
    urlPrefix: `${config.publicPath}/registrations`,
    icon: 'registration',
    defaultMessage: 'Registrations',
    message: 'sidebar.registrations',
    roles: [ROLES.GOP_STAFF.u, ROLES.NAO_STAFF.u, ROLES.OA.u, ROLES.SOA.u, ROLES.GBT.u],
    counters: [
      TASKS_OVERVIEW.AU_REGISTRATION.id,
      TASKS_OVERVIEW.AL_REGISTRATION.id,
      TASKS_OVERVIEW.AWARD_REGISTRATION.id,
      TASKS_OVERVIEW.UNASSIGNED_PARTICIPANTS.id
    ]
  },
  {
    id: 4,
    url: `${config.publicPath}/payments`,
    urlPrefix: `${config.publicPath}/payments`,
    icon: 'bill',
    defaultMessage: 'Payments',
    message: 'sidebar.payments',
    roles: [ROLES.GOP_STAFF.u, ROLES.NAO_STAFF.u, ROLES.OA.u, ROLES.SOA.u],
    configs: [
      CONFIGURATION_KEYS.onlineMasterCardPayment.id,
      CONFIGURATION_KEYS.onlinePayPalPayment.id
    ],
    counters: [TASKS_OVERVIEW.PAYMENTS.id]
  },
  {
    id: 5,
    url: `${config.publicPath}/awards/office-signoffs`,
    urlPrefix: `${config.publicPath}/awards`,
    icon: 'award',
    defaultMessage: 'Award Signoffs',
    message: 'sidebar.award_signoffs',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.GBT.u
    ],
    counters: [
      TASKS_OVERVIEW.AWARD_OFFICE_SIGNOFF.id,
      TASKS_OVERVIEW.AWARD_OFFICE_SIGNOFF_LOCALLY.id]
  },
  {
    id: 6,
    url: `${config.publicPath}/award-overview/award-overview`,
    urlPrefix: `${config.publicPath}/award-overview`,
    icon: 'award-signoff',
    defaultMessage: 'Awards',
    message: 'sidebar.awards_overview',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.LEADER.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u
    ]
  },
  {
    id: 7,
    url: `${config.publicPath}/awards/local-office-signoffs`,
    urlPrefix: `${config.publicPath}/awards`,
    icon: 'award',
    defaultMessage: 'Awards',
    message: 'sidebar.awards',
    roles: [
      ROLES.AWARD_VERIFIER.u
    ],
    counters: [
      TASKS_OVERVIEW.AWARD_OFFICE_SIGNOFF.id,
      TASKS_OVERVIEW.AWARD_OFFICE_SIGNOFF_LOCALLY.id]
  },
  {
    id: 8,
    url: `${config.publicPath}/participants/my-participants`,
    urlPrefix: `${config.publicPath}/participants`,
    icon: 'participants',
    defaultMessage: 'Participants',
    message: 'sidebar.participants',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.LEADER.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u
    ]
  },
  {
    id: 9,
    url: `${config.publicPath}/leaders`,
    urlPrefix: `${config.publicPath}/leaders`,
    icon: 'leader',
    defaultMessage: 'Leaders',
    message: 'sidebar.leaders',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.LEADER.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u
    ]
  },
  {
    id: 10,
    url: `${config.publicPath}/award-units`,
    urlPrefix: `${config.publicPath}/award-units`,
    icon: 'house',
    defaultMessage: 'Award units',
    message: 'sidebar.award_units',
    roles: [
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u
    ]
  },
  {
    id: 11,
    url: `${config.publicPath}/aus-iacs`,
    urlPrefix: `${config.publicPath}/aus-iacs`,
    icon: 'house',
    defaultMessage: 'Organizations',
    message: 'sidebar.organizations',
    roles: [ROLES.GOP_STAFF.u]
  },
  {
    id: 12,
    url: `${config.publicPath}/independent-award-centres`,
    urlPrefix: `${config.publicPath}/independent-award-centres`,
    icon: 'briefcase',
    defaultMessage: 'IACs',
    message: 'sidebar.independent_award_centers',
    roles: [ROLES.GBT.u, ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u]
  },
  {
    id: 13,
    url: `${config.publicPath}/adventurous-journeys/my-events`,
    urlPrefix: `${config.publicPath}/adventurous-journeys`,
    icon: 'aj',
    defaultMessage: 'AJ Events',
    message: 'sidebar.adventure_journey',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.LEADER.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u
    ]
  },
  {
    id: 14,
    url: `${config.publicPath}/assessors/all`,
    urlPrefix: `${config.publicPath}/assessors`,
    icon: 'participants',
    defaultMessage: 'Assessors',
    message: 'sidebar.assessors',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.LEADER.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u
    ],
    configs: [CONFIGURATION_KEYS.manageAssessors.id]
  },
  {
    id: 15,
    url: `${config.publicPath}/sub-operating-authorities`,
    urlPrefix: `${config.publicPath}/sub-operating-authorities`,
    icon: 'briefcase',
    defaultMessage: 'Sub-Operating Authorities',
    message: 'sidebar.suboperating_authorities',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u
    ]
  },
  {
    id: 16,
    url: `${config.publicPath}/operating-authorities`,
    urlPrefix: `${config.publicPath}/operating-authorities`,
    icon: 'briefcase',
    defaultMessage: 'Operating Authorities',
    message: 'sidebar.operating_authorities',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u
    ]
  },
  {
    id: 17,
    url: `${config.publicPath}/national-offices`,
    urlPrefix: `${config.publicPath}/national-offices`,
    icon: 'briefcase',
    defaultMessage: 'NAOs',
    message: 'sidebar.naos',
    roles: [ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u, ROLES.IF_REGION.u]
  },
  {
    id: 18,
    url: `${config.publicPath}/global-operating-partners`,
    urlPrefix: `${config.publicPath}/global-operating-partners`,
    icon: 'briefcase',
    defaultMessage: 'GOPs',
    message: 'sidebar.gops',
    roles: [ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u, ROLES.IF_REGION.u],
    configuration: CONFIGURATION_KEYS.isGOPEnabled.id
  },
  {
    id: 19,
    url: `${config.publicPath}/sub-global-operating-partners`,
    urlPrefix: `${config.publicPath}/sub-global-operating-partners`,
    icon: 'briefcase',
    defaultMessage: 'SGOPs',
    message: 'sidebar.sgops',
    roles: [ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u, ROLES.IF_REGION.u, ROLES.GOP_STAFF.u],
    orgHierarchyTypes: [ORGANIZATION_HIERARCHY.IAF.value, ORGANIZATION_HIERARCHY.RO.value, ORGANIZATION_HIERARCHY.NAO.value, ORGANIZATION_HIERARCHY.IAC.value,
      ORGANIZATION_HIERARCHY.AU.value, ORGANIZATION_HIERARCHY.OA.value, ORGANIZATION_HIERARCHY.SOA.value, ORGANIZATION_HIERARCHY.IC.value, ORGANIZATION_HIERARCHY.GOP.value],
    configuration: CONFIGURATION_KEYS.isGOPEnabled.id
  },
  {
    id: 20,
    url: `${config.publicPath}/independent-countries`,
    urlPrefix: `${config.publicPath}/independent-countries`,
    icon: 'briefcase',
    defaultMessage: 'ICs',
    message: 'sidebar.ics',
    roles: [ROLES.GOP_STAFF.u, ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u, ROLES.GBT.u]
  },
  {
    id: 21,
    url: `${config.publicPath}/regions`,
    urlPrefix: `${config.publicPath}/regions`,
    icon: 'region',
    defaultMessage: 'Regions',
    message: 'sidebar.regions',
    roles: [ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u]
  },
  {
    id: 22,
    url: `${config.publicPath}/guides-and-policies`,
    urlPrefix: `${config.publicPath}/guides-and-policies`,
    icon: 'guide',
    defaultMessage: 'Guides and Policies',
    message: 'sidebar.guides_and_policies',
    roles: [ROLES.LEADER.u, ROLES.NAO_STAFF.u, ROLES.OA.u, ROLES.SOA.u]
  },
  {
    id: 23,
    url: `${config.publicPath}/reports`,
    urlPrefix: `${config.publicPath}/reports`,
    icon: 'report',
    defaultMessage: 'Reports',
    message: 'sidebar.reports',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u,
      ROLES.LEADER.u
    ]
  },
  {
    id: 24,
    url: `${config.publicPath}/my-office/detail`,
    urlPrefix: `${config.publicPath}/my-office`,
    icon: 'settings',
    defaultMessage: 'My Office',
    message: 'sidebar.my_office',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u
    ]
  },
  {
    id: 25,
    url: `${config.publicPath}/my-organization/detail`,
    urlPrefix: `${config.publicPath}/my-organization`,
    icon: 'settings',
    defaultMessage: 'My Organization',
    message: 'sidebar.my_organization',
    roles: [ROLES.LEADER.u]
  },
  {
    id: 26,
    url: `${config.publicPath}/my-national-office/detail`,
    urlPrefix: `${config.publicPath}/my-national-office`,
    icon: 'settings',
    defaultMessage: 'My Office',
    message: 'sidebar.my_office',
    roles: [ROLES.NAO_STAFF.u, ROLES.OA.u, ROLES.SOA.u]
  },
  {
    id: 27,
    url: `${config.publicPath}/data-import`,
    urlPrefix: `${config.publicPath}/data-import`,
    icon: 'import',
    defaultMessage: 'Manual data import',
    message: 'sidebar.manual_data_import',
    roles: [ROLES.GOP_STAFF.u, ROLES.IF_STAFF_SUPER.u, ROLES.IF_STAFF_VIEWER.u, ROLES.NAO_STAFF.u]
  },
  {
    id: 28,
    url: `${config.publicPath}/translations-management`,
    urlPrefix: `${config.publicPath}/translations-management`,
    icon: 'translate',
    defaultMessage: 'Translations Management',
    message: 'sidebar.translations_managment',
    roles: [ROLES.IF_STAFF_SUPER.u]
  },
  {
    id: 29,
    url: `${config.publicPath}/support`,
    urlPrefix: `${config.publicPath}/support`,
    icon: 'cubes',
    defaultMessage: 'Support',
    message: 'sidebar.support',
    roles: [ROLES.IF_STAFF_SUPER.u, ROLES.IF_REGION.u, ROLES.NAO_STAFF.u, ROLES.GBT.u]
  },
  {
    id: 30,
    url: `${config.publicPath}/message-center`,
    urlPrefix: `${config.publicPath}/message-center`,
    icon: 'chat',
    defaultMessage: 'Message Center',
    message: 'sidebar.message_center',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u,
      ROLES.LEADER.u
    ],
    configuration: CONFIGURATION_KEYS.isMessagingEnabled.id
  },
  {
    id: 31,
    url: `${config.publicPath}/orb-lab`,
    urlPrefix: `${config.publicPath}/orb-lab`,
    icon: 'lab',
    defaultMessage: 'ORB Lab',
    message: 'sidebar.orb_lab',
    roles: [
      ROLES.GOP_STAFF.u,
      ROLES.NAO_STAFF.u,
      ROLES.OA.u,
      ROLES.SOA.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_STAFF_VIEWER.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_REGION.u,
      ROLES.GBT.u,
      ROLES.LEADER.u
    ],
    forTestUserOnly: true
    }
  ]
